<div class="subscribe-main">
  <form [formGroup]="appsForm">
    <div class="subscribe-title-div">
      <img
        *ngIf="apiData.visibility === 'Partner'"
        src="./assets/images/icons/lock_solid.svg"
        width="48px"
        height="48px"
        alt="Partner API - secure access required" />
      <h3 class="subscribe-title">{{ apiData.name }}</h3>
    </div>
    <p class="subscribe-instructions">{{ apiMessageText }}</p>

    <p class="subscribe-choose-text" id="choose-app-label">Choose application:</p>

    <div class="subscribe-form">
      <div
        class="subscribe-form-group-div"
        role="group"
        aria-labelledby="choose-app-label">
        <span *ngFor="let app of applicationsData">
          <mat-checkbox
            [disabled]="
              !(
                apiData.visibility === 'public' ||
                (apiData.visibility === 'partner' &&
                  (app.applicationPersona === 'developer' || app.applicationPersona === 'partner')) ||
                apiData.visibility === app.applicationPersona
              )
            "
            color="primary"
            [formControlName]="app.id"
            [attr.aria-label]="
              app.name +
              (!(
                apiData.visibility === 'public' ||
                (apiData.visibility === 'partner' &&
                  (app.applicationPersona === 'developer' || app.applicationPersona === 'partner')) ||
                apiData.visibility === app.applicationPersona
              )
                ? ' — not supported for ' + apiData?.visibility + ' API'
                : '')
            ">{{ app.name }}
          </mat-checkbox>

          <span
            *ngIf="
              !(
                apiData.visibility === 'public' ||
                (apiData.visibility === 'partner' &&
                  (app.applicationPersona === 'developer' || app.applicationPersona === 'partner')) ||
                apiData.visibility === app.applicationPersona
              )
            "
            style="position: relative; top: 0.5rem; left: 0.5rem">
            <span
              class="app-nav-item"
              [matMenuTriggerFor]="menu"
              #menuTrigger="matMenuTrigger"
              tabindex="0"
              role="button"
              [attr.aria-label]="'Info: This application does not support ' + apiData?.visibility + ' API'"
              aria-haspopup="true"
              (mouseenter)="mouseEnter(menuTrigger)"
              (mouseleave)="mouseLeave(menuTrigger)"
              (keydown.enter)="mouseEnter(menuTrigger)"
              (keydown.space)="mouseEnter(menuTrigger)"
              (keydown.escape)="mouseLeave(menuTrigger)"
              (focusout)="mouseLeave(menuTrigger)">
              <mat-icon aria-hidden="true">info</mat-icon>
            </span>
            <mat-menu #menu="matMenu" [hasBackdrop]="false">
              <div (mouseenter)="mouseEnter(menuTrigger)" (mouseleave)="mouseLeave(menuTrigger)">
                <div content class="menu-content-api">
                  <div class="menu-item">
                    <div>
                      <span class="menu-description">
                        This application does not support {{ apiData?.visibility }} API.
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </mat-menu>
          </span>
        </span>
      </div>
    </div>
  </form>

  <div class="actions-div">
    <div class="subscribe-email-div" aria-live="polite">
      <span>You will receive email updates on planned maintenance, outages, and other API-specific information.</span>
    </div>

    <div class="button-div">
      <button
        class="secondary-action-button"
        aria-label="Cancel and close subscription dialog"
        (click)="onCancel()">
        Cancel
      </button>

      <button
        *ngIf="!appsForm.errors"
        class="primary-action-button"
        [attr.aria-label]="
          apiData.visibility === 'Public'
            ? 'OK. Select this button to submit'
            : 'Request Access. Select this button to request access for this API'
        "
        (click)="onSubmit()">
        {{ apiData.visibility === 'Public' ? 'OK' : 'Request Access' }}
      </button>
      <button
        *ngIf="appsForm.errors"
        class="primary-disabled-action-button"
        [class.disabled]="apiData.visibility !== 'Public'"
        [attr.aria-disabled]="apiData.visibility !== 'Public'"
        [attr.aria-label]="
          apiData.visibility === 'Public'
            ? 'OK. This button is currently disabled'
            : 'Request Access. This button is currently disabled'
        ">
        {{ apiData.visibility === 'Public' ? 'OK' : 'Request Access' }}
      </button>
    </div>
  </div>
</div>
